import Head from 'next/head';
import { Header } from '@components/Header';
import { Footer } from '@/components/Footer';
import { AssetsPrefetchLinks, FavIconLinks, MetaTags } from '@eventbrite/webapp-public-content';
import { BaseProps } from '@/types';

export interface ErrorPageProps extends BaseProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export function ErrorPage({ title, description, children, stage }: ErrorPageProps): JSX.Element {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex, nofollow" />
        <AssetsPrefetchLinks />
        <FavIconLinks stage={stage} />
        <MetaTags locale="en" />
      </Head>
      <Header />
      {children}
      <Footer />
    </>
  );
}
